import React, { useState } from 'react';
import VeterinarySlideshowBackground from '../components/VeterinarySlideshowBackground';
import { Search, MapPin, GraduationCap, Star, Phone, Mail, Award, Users } from 'lucide-react';
import { usePagination } from '../hooks/usePagination';
import PaginationControls from '../components/PaginationControls';

interface VeterinaryCollege {
  id: number;
  name: string;
  shortName: string;
  location: string;
  state: string;
  approvals: string[];
  rating: number;
  reviewCount: number;
  bestIn: string;
  fees: string;
  course: string;
  neetCutoff?: string;
  accreditation?: string;
  phone?: string;
  email?: string;
  address: string;
}

const veterinaryColleges: VeterinaryCollege[] = [
  {
    id: 1,
    name: "NTR College of Veterinary Science",
    shortName: "NTRCVS",
    location: "Gannavaram",
    state: "Andhra Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 156,
    bestIn: "Infrastructure",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Gannavaram, Andhra Pradesh"
  },
  {
    id: 2,
    name: "College of Veterinary Science",
    shortName: "CVS",
    location: "Proddatur",
    state: "Andhra Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 120,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Proddatur, Andhra Pradesh"
  },
  {
    id: 3,
    name: "College of Veterinary Science",
    shortName: "CVS",
    location: "Tirupati",
    state: "Andhra Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.2,
    reviewCount: 180,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Tirupati, Andhra Pradesh"
  },
  {
    id: 4,
    name: "College of Veterinary Science",
    shortName: "CVS",
    location: "Guwahati",
    state: "Assam",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 95,
    bestIn: "Infrastructure",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Guwahati, Assam"
  },
  {
    id: 5,
    name: "College of Veterinary Science",
    shortName: "CVS",
    location: "Lakhimpur",
    state: "Assam",
    approvals: ["ICAR", "VCI"],
    rating: 3.8,
    reviewCount: 45,
    bestIn: "Faculty",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Lakhimpur, Assam"
  },
  {
    id: 6,
    name: "Bihar Veterinary College",
    shortName: "BVC",
    location: "Patna",
    state: "Bihar",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 135,
    bestIn: "Academics",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Patna, Bihar"
  },
  {
    id: 7,
    name: "College of Veterinary Science & Animal Husbandry",
    shortName: "CVSAH",
    location: "Durg",
    state: "Chhattisgarh",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 110,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Durg, Chhattisgarh"
  },
  {
    id: 8,
    name: "College of Veterinary Science and Animal Husbandry",
    shortName: "CVSAH",
    location: "Anand",
    state: "Gujarat",
    approvals: ["ICAR", "VCI"],
    rating: 4.2,
    reviewCount: 165,
    bestIn: "Infrastructure",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Anand, Gujarat"
  },
  {
    id: 9,
    name: "College of Veterinary Science and Animal Husbandry",
    shortName: "CVSAH",
    location: "Junagadh",
    state: "Gujarat",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 140,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Junagadh, Gujarat"
  },
  {
    id: 10,
    name: "College of Veterinary Science and Animal Husbandry",
    shortName: "CVSAH",
    location: "Navsari",
    state: "Gujarat",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 125,
    bestIn: "Faculty",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Navsari, Gujarat"
  },
  {
    id: 11,
    name: "College of Veterinary Science and Animal Husbandry",
    shortName: "CVSAH",
    location: "Sardarkrushinagar",
    state: "Gujarat",
    approvals: ["ICAR", "VCI"],
    rating: 3.9,
    reviewCount: 115,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Sardarkrushinagar, Gujarat"
  },
  {
    id: 12,
    name: "College of Veterinary Science",
    shortName: "CVS",
    location: "Hisar",
    state: "Haryana",
    approvals: ["ICAR", "VCI"],
    rating: 4.3,
    reviewCount: 190,
    bestIn: "Overall Excellence",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Hisar, Haryana"
  },
  {
    id: 13,
    name: "International Institute of Veterinary Education and Research",
    shortName: "IIVER",
    location: "Rohtak",
    state: "Haryana",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 145,
    bestIn: "International Exposure",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Bahu Akbarpur, Rohtak, Haryana",
    accreditation: "Private Institution"
  },
  {
    id: 14,
    name: "Dr. G.C. Negi College of Veterinary and Animal Sciences",
    shortName: "GCNVAS",
    location: "Palampur",
    state: "Himachal Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 120,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Palampur, Himachal Pradesh"
  },
  {
    id: 15,
    name: "Faculty of Veterinary Sciences & Animal Husbandry",
    shortName: "FVSAH",
    location: "Jammu",
    state: "Jammu & Kashmir",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 135,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Jammu, Jammu & Kashmir"
  },
  {
    id: 16,
    name: "Faculty of Veterinary Sciences & Animal Husbandry",
    shortName: "FVSAH",
    location: "Srinagar",
    state: "Jammu & Kashmir",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 110,
    bestIn: "Faculty",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Srinagar, Kashmir"
  },
  {
    id: 17,
    name: "Veterinary College Hebbal",
    shortName: "VCH",
    location: "Bengaluru",
    state: "Karnataka",
    approvals: ["ICAR", "VCI"],
    rating: 4.3,
    reviewCount: 180,
    bestIn: "Overall Excellence",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Hebbal, Bengaluru, Karnataka"
  },
  {
    id: 18,
    name: "Veterinary College",
    shortName: "VC",
    location: "Bidar",
    state: "Karnataka",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 125,
    bestIn: "Infrastructure",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Nandinagar, Bidar, Karnataka"
  },
  {
    id: 19,
    name: "Veterinary College",
    shortName: "VC",
    location: "Hassan",
    state: "Karnataka",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 140,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Hassan, Karnataka"
  },
  {
    id: 20,
    name: "Veterinary College",
    shortName: "VC",
    location: "Shimoga",
    state: "Karnataka",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 130,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Shimoga, Karnataka"
  },
  {
    id: 21,
    name: "Veterinary College",
    shortName: "VC",
    location: "Gadag",
    state: "Karnataka",
    approvals: ["ICAR", "VCI"],
    rating: 3.9,
    reviewCount: 95,
    bestIn: "Faculty",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Gadag, Karnataka"
  },
  {
    id: 22,
    name: "College of Veterinary & Animal Sciences",
    shortName: "CVAS",
    location: "Thrissur",
    state: "Kerala",
    approvals: ["ICAR", "VCI"],
    rating: 4.3,
    reviewCount: 175,
    bestIn: "Overall Excellence",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Thrissur, Kerala"
  },
  {
    id: 23,
    name: "College of Veterinary and Animal Sciences",
    shortName: "CVAS",
    location: "Pookote",
    state: "Kerala",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 145,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Pookote, Kerala"
  },
  {
    id: 24,
    name: "College of Veterinary Science & Animal Husbandry",
    shortName: "CVSAH",
    location: "Jabalpur",
    state: "Madhya Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.2,
    reviewCount: 160,
    bestIn: "Infrastructure",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Jabalpur, Madhya Pradesh"
  },
  {
    id: 25,
    name: "College of Veterinary Science & Animal Husbandry",
    shortName: "CVSAH",
    location: "Mhow",
    state: "Madhya Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 130,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Mhow, Madhya Pradesh"
  },
  {
    id: 26,
    name: "College of Veterinary Science & Animal Husbandry",
    shortName: "CVSAH",
    location: "Rewa",
    state: "Madhya Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 140,
    bestIn: "Faculty",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Rewa, Madhya Pradesh"
  },
  {
    id: 27,
    name: "Mumbai Veterinary College",
    shortName: "MVC",
    location: "Mumbai",
    state: "Maharashtra",
    approvals: ["ICAR", "VCI"],
    rating: 4.3,
    reviewCount: 185,
    bestIn: "Overall Excellence",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Mumbai, Maharashtra"
  },
  {
    id: 28,
    name: "Nagpur Veterinary College",
    shortName: "NVC",
    location: "Nagpur",
    state: "Maharashtra",
    approvals: ["ICAR", "VCI"],
    rating: 4.2,
    reviewCount: 155,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Nagpur, Maharashtra"
  },
  {
    id: 29,
    name: "College of Veterinary & Animal Sciences",
    shortName: "CVAS",
    location: "Parbhani",
    state: "Maharashtra",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 140,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Parbhani, Maharashtra"
  },
  {
    id: 30,
    name: "K.N.P. College of Veterinary Sciences",
    shortName: "KNPCVS",
    location: "Satara",
    state: "Maharashtra",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 120,
    bestIn: "Infrastructure",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Satara, Maharashtra"
  },
  {
    id: 31,
    name: "College of Veterinary & Animal Sciences",
    shortName: "CVAS",
    location: "Udgir",
    state: "Maharashtra",
    approvals: ["ICAR", "VCI"],
    rating: 3.9,
    reviewCount: 110,
    bestIn: "Faculty",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Udgir, Maharashtra"
  },
  {
    id: 32,
    name: "College of Veterinary Science & Animal Husbandry",
    shortName: "CVSAH",
    location: "Aizawl",
    state: "Mizoram",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 95,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Aizawl, Mizoram"
  },
  {
    id: 33,
    name: "College of Veterinary Science",
    shortName: "CVS",
    location: "Jalukie",
    state: "Nagaland",
    approvals: ["ICAR", "VCI"],
    rating: 3.8,
    reviewCount: 75,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Jalukie, Peren, Nagaland"
  },
  {
    id: 34,
    name: "College of Veterinary Science and Animal Husbandry",
    shortName: "CVSAH",
    location: "Bhubaneswar",
    state: "Odisha",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 150,
    bestIn: "Overall Excellence",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Bhubaneswar, Odisha"
  },
  {
    id: 35,
    name: "Rajiv Gandhi College of Veterinary & Animal Sciences",
    shortName: "RGCVAS",
    location: "Puducherry",
    state: "Puducherry",
    approvals: ["ICAR", "VCI"],
    rating: 4.2,
    reviewCount: 160,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Puducherry"
  },
  {
    id: 36,
    name: "Khalsa College of Veterinary and Animal Sciences",
    shortName: "KCVAS",
    location: "Amritsar",
    state: "Punjab",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 145,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Amritsar, Punjab",
    accreditation: "Private Institution"
  },
  {
    id: 37,
    name: "College of Veterinary Science",
    shortName: "CVS",
    location: "Ludhiana",
    state: "Punjab",
    approvals: ["ICAR", "VCI"],
    rating: 4.3,
    reviewCount: 175,
    bestIn: "Overall Excellence",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Ludhiana, Punjab"
  },
  {
    id: 38,
    name: "College of Veterinary and Animal Science",
    shortName: "CVAS",
    location: "Bikaner",
    state: "Rajasthan",
    approvals: ["ICAR", "VCI"],
    rating: 4.2,
    reviewCount: 165,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Bikaner, Rajasthan"
  },
  {
    id: 39,
    name: "Mahatma Jyotiba Fule College of Veterinary & Animal Science",
    shortName: "MJFCVAS",
    location: "Chomu",
    state: "Rajasthan",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 130,
    bestIn: "Infrastructure",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Chomu, Jaipur, Rajasthan",
    accreditation: "Private Institution"
  },
  {
    id: 40,
    name: "Apollo College of Veterinary Medicine",
    shortName: "ACVM",
    location: "Jaipur",
    state: "Rajasthan",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 140,
    bestIn: "Faculty",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Jaipur, Rajasthan",
    accreditation: "Private Institution"
  },
  {
    id: 41,
    name: "Post Graduate Institute of Veterinary Education and Research",
    shortName: "PGIVER",
    location: "Jaipur",
    state: "Rajasthan",
    approvals: ["ICAR", "VCI"],
    rating: 4.3,
    reviewCount: 170,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Jaipur, Rajasthan"
  },
  {
    id: 42,
    name: "College of Veterinary and Animal Science",
    shortName: "CVAS",
    location: "Udaipur",
    state: "Rajasthan",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 150,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Navania, Udaipur, Rajasthan"
  },
  {
    id: 43,
    name: "Arawali Veterinary College",
    shortName: "AVC",
    location: "Sikar",
    state: "Rajasthan",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 125,
    bestIn: "Infrastructure",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Sikar, Rajasthan",
    accreditation: "Private Institution"
  },
  {
    id: 44,
    name: "College of Veterinary Science",
    shortName: "CVS",
    location: "Hyderabad",
    state: "Telangana",
    approvals: ["ICAR", "VCI"],
    rating: 4.2,
    reviewCount: 160,
    bestIn: "Overall Excellence",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Hyderabad, Telangana"
  },
  {
    id: 45,
    name: "College of Veterinary Science",
    shortName: "CVS",
    location: "Korutla",
    state: "Telangana",
    approvals: ["ICAR", "VCI"],
    rating: 4.0,
    reviewCount: 130,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Korutla, Telangana"
  },
  {
    id: 46,
    name: "College of Veterinary Science and Animal Husbandry",
    shortName: "CVSAH",
    location: "Mathura",
    state: "Uttar Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.2,
    reviewCount: 155,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Mathura, Uttar Pradesh"
  },
  {
    id: 47,
    name: "ICAR - Indian Veterinary Research Institute",
    shortName: "IVRI",
    location: "Bareilly",
    state: "Uttar Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.5,
    reviewCount: 200,
    bestIn: "Research Excellence",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Izatnagar, Bareilly, Uttar Pradesh"
  },
  {
    id: 48,
    name: "Faculty of Veterinary and Animal Sciences",
    shortName: "FVAS",
    location: "Varanasi",
    state: "Uttar Pradesh",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 140,
    bestIn: "Education",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "RGSC, Barkachha, Varanasi, Uttar Pradesh"
  },
  {
    id: 49,
    name: "College of Veterinary & Animal Sciences",
    shortName: "CVAS",
    location: "Pantnagar",
    state: "Uttarakhand",
    approvals: ["ICAR", "VCI"],
    rating: 4.2,
    reviewCount: 150,
    bestIn: "Overall Excellence",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Pantnagar, Uttarakhand"
  },
  {
    id: 50,
    name: "Faculty of Veterinary & Animal Sciences",
    shortName: "FVAS",
    location: "Mohanpur",
    state: "West Bengal",
    approvals: ["ICAR", "VCI"],
    rating: 4.1,
    reviewCount: 145,
    bestIn: "Research",
    fees: "Contact College",
    course: "BVSc & AH",
    address: "Mohanpur, Nadia, West Bengal"
  }
];

const VeterinaryPage: React.FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState<'name' | 'rating' | 'fees'>('name');
  const [filterByState, setFilterByState] = useState('');

  // Filter colleges based on search and filters
  const filteredColleges = veterinaryColleges.filter(college => {
    const matchesSearch = college.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         college.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         college.course.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesState = filterByState === '' || college.state === filterByState;
    return matchesSearch && matchesState;
  });

  // Sort colleges
  const sortedColleges = [...filteredColleges].sort((a, b) => {
    switch (sortBy) {
      case 'rating':
        return b.rating - a.rating;
      case 'fees':
        // Simple fee comparison (this would need more sophisticated logic for real implementation)
        return a.fees.localeCompare(b.fees);
      default:
        return a.name.localeCompare(b.name);
    }
  });

  // Pagination
  const {
    currentPage,
    totalPages,
    currentItems: paginatedColleges,
    itemsPerPage,
    startIndex,
    endIndex,
    handleNextPage,
    handlePrevPage,
    setItemsPerPage,
    goToPage
  } = usePagination({ data: sortedColleges, initialItemsPerPage: 6 });

  const states = [...new Set(veterinaryColleges.map(college => college.state))];

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      {/* Veterinary Slideshow Background */}
      <div className="mb-8">
        <VeterinarySlideshowBackground />
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Veterinary Colleges in India
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Discover top veterinary colleges offering BVSc, Animal Husbandry, and related programs. 
            Find the perfect institution for your career in veterinary science and animal care.
          </p>
        </div>

        {/* Search and Filters */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {/* Search */}
            <div className="relative">
              <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
              <input
                type="text"
                placeholder="Search colleges, locations, courses..."
                className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* State Filter */}
            <select
              title="Filter by state"
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={filterByState}
              onChange={(e) => setFilterByState(e.target.value)}
            >
              <option value="">All States</option>
              {states.map(state => (
                <option key={state} value={state}>{state}</option>
              ))}
            </select>

            {/* Sort */}
            <select
              title="Sort colleges by"
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              value={sortBy}
              onChange={(e) => setSortBy(e.target.value as 'name' | 'rating' | 'fees')}
            >
              <option value="name">Sort by Name</option>
              <option value="rating">Sort by Rating</option>
              <option value="fees">Sort by Fees</option>
            </select>
          </div>
        </div>

        {/* Results Summary */}
        <div className="mb-6">
          <p className="text-gray-600">
            Showing {paginatedColleges.length} of {filteredColleges.length} veterinary colleges
          </p>
        </div>

        {/* College Cards */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mb-8">
          {paginatedColleges.map((college: VeterinaryCollege) => (
            <div key={college.id} className="bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="p-6">
                {/* Header */}
                <div className="flex justify-between items-start mb-4">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-2">
                      <h3 className="text-xl font-bold text-gray-900 line-clamp-2">
                        {college.name}
                      </h3>
                      {college.shortName && (
                        <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2 py-1 rounded">
                          {college.shortName}
                        </span>
                      )}
                    </div>
                    <div className="flex items-center text-gray-600 mb-2">
                      <MapPin className="h-4 w-4 mr-1" />
                      <span>{college.location}, {college.state}</span>
                    </div>
                  </div>
                  
                  {/* Rating */}
                  <div className="text-right">
                    <div className="flex items-center">
                      <Star className="h-4 w-4 text-yellow-400 fill-current mr-1" />
                      <span className="font-semibold">{college.rating}</span>
                    </div>
                    <p className="text-xs text-gray-500">
                      Based on {college.reviewCount} reviews
                    </p>
                  </div>
                </div>

                {/* Course and Fees */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
                  <div>
                    <div className="flex items-center text-gray-700 mb-1">
                      <GraduationCap className="h-4 w-4 mr-2" />
                      <span className="font-medium">{college.course}</span>
                    </div>
                    {college.neetCutoff && (
                      <p className="text-sm text-blue-600">{college.neetCutoff}</p>
                    )}
                  </div>
                  <div>
                    <p className="text-lg font-bold text-green-600">{college.fees}</p>
                    <p className="text-sm text-gray-500">1st Year Fees</p>
                  </div>
                </div>

                {/* Approvals */}
                <div className="mb-4">
                  <div className="flex flex-wrap gap-1">
                    {college.approvals.map((approval: string, index: number) => (
                      <span
                        key={index}
                        className="bg-green-100 text-green-800 text-xs font-medium px-2 py-1 rounded"
                      >
                        {approval}
                      </span>
                    ))}
                    {college.accreditation && (
                      <span className="bg-purple-100 text-purple-800 text-xs font-medium px-2 py-1 rounded">
                        {college.accreditation}
                      </span>
                    )}
                  </div>
                </div>

                {/* Best In */}
                <div className="mb-4">
                  <div className="flex items-center">
                    <Award className="h-4 w-4 text-orange-500 mr-2" />
                    <span className="text-sm font-medium text-orange-600">
                      Best in {college.bestIn}
                    </span>
                  </div>
                </div>

                {/* Contact Info */}
                {(college.phone || college.email) && (
                  <div className="border-t pt-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Contact Information</h4>
                    <div className="space-y-1">
                      {college.phone && (
                        <div className="flex items-center text-sm text-gray-600">
                          <Phone className="h-4 w-4 mr-2" />
                          <span>{college.phone}</span>
                        </div>
                      )}
                      {college.email && (
                        <div className="flex items-center text-sm text-gray-600">
                          <Mail className="h-4 w-4 mr-2" />
                          <span>{college.email}</span>
                        </div>
                      )}
                      <div className="flex items-start text-sm text-gray-600">
                        <MapPin className="h-4 w-4 mr-2 mt-1 flex-shrink-0" />
                        <span>{college.address}</span>
                      </div>
                    </div>
                  </div>
                )}

                
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <PaginationControls
            currentPage={currentPage}
            totalPages={totalPages}
            itemsPerPage={itemsPerPage}
            totalItems={sortedColleges.length}
            startIndex={startIndex}
            endIndex={endIndex}
            onPageChange={goToPage}
            onPrevPage={handlePrevPage}
            onNextPage={handleNextPage}
            onItemsPerPageChange={setItemsPerPage}
          />
        )}

        {/* No Results */}
        {filteredColleges.length === 0 && (
          <div className="text-center py-12">
            <Users className="h-16 w-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-xl font-semibold text-gray-900 mb-2">No veterinary colleges found</h3>
            <p className="text-gray-600">
              Try adjusting your search criteria or filters to find more results.
            </p>
          </div>
        )}

        {/* Additional Information */}
        <div className="mt-12 bg-white rounded-lg shadow-md p-6">
          <h2 className="text-2xl font-bold text-gray-900 mb-4">About Veterinary Education in India</h2>
          <div className="prose max-w-none text-gray-600">
            <p className="mb-4">
              Veterinary science is a vital field that focuses on the health and welfare of animals. 
              The Bachelor of Veterinary Science and Animal Husbandry (BVSc & AH) is the primary 
              undergraduate degree in this field in India.
            </p>
            <p className="mb-4">
              The veterinary colleges listed above are recognized institutions that offer quality 
              education in veterinary science, animal husbandry, dairy technology, and fisheries. 
              Most programs are regulated by the Indian Council of Agricultural Research (ICAR).
            </p>
            <p>
              Admission to most veterinary colleges is through NEET (National Eligibility cum Entrance Test), 
              and graduates can pursue careers as veterinarians, animal welfare officers, research scientists, 
              or start their own veterinary practice.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VeterinaryPage;
